import '@theme/theme-drawer';
import { sectionRenderer } from '@theme/section-renderer';
let opening = false;
window.addEventListener('click', async event => {
  const trigger = event.target.closest?.('[data-varevo-open-cart]');
  if (!trigger) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (opening) return;
  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (!drawer) return;
  if (drawer.hasAttribute('open')) { drawer.close(); return; }
  opening = true;
  trigger.setAttribute('aria-busy', 'true');
  try {
    const url = new URL(location.href);
    if (window.varevoPreviewThemeId) url.searchParams.set('preview_theme_id', window.varevoPreviewThemeId);
    await sectionRenderer.renderSection('cart-drawer-section', {cache:false,mode:'full',injectStylesheet:true,url});
    await customElements.whenDefined('theme-drawer');
    document.querySelector('theme-drawer#cart-drawer')?.open();
  } catch (error) {
    console.warn('[varevo-cart] Cart refresh failed', error);
    await customElements.whenDefined('theme-drawer');
    document.querySelector('theme-drawer#cart-drawer')?.open();
  } finally {
    opening = false;
    trigger.removeAttribute('aria-busy');
  }
}, {capture:true});
